import gql from 'graphql-tag';

export const GEOGRAPHICAL_EXPOSURE_QUERY = gql`
    query GeoGraphicalExposure($ticker: String!) {
        mutualFund(ticker: $ticker) {
            inceptionDate
            countryRankings {
                rank
                name
                percentTotalNetAssets
                asOfDate
            }
        }
    }
`;

export const ETF_GEOGRAPHICAL_EXPOSURE_QUERY = gql`
    query GeoGraphicalExposure($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            inceptionDate
            countryAllocation {
                asOfDate
                availableDates
                oneMonthAllocation {
                    fundAllocationData {
                        name
                        percentTotalNetAssets: allocationPercent
                    }
                }
            }
        }
    }
`;
